export interface AccredibleObjectWithId {
  id: string | number;

  [key: string]: unknown;
}
